import React, { useState, useEffect } from 'react'
import { db } from './firebase';
import './Orders.css';
import { useStateValue } from "./StateProvider";
import Order from './Order';
function Orders() {
    const [orders, setOrders] = useState([]);
    const [{ basket, user }, dispatch] = useStateValue();
    useEffect(() => {

        if(user) {
            db
            .collection('users')
            .doc(user?.uid)
            .collection('orders')
            .orderBy('created', 'desc')
            .onSnapshot(snapshot => {
                setOrders(snapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })))
            })
        } else {
            setOrders([])
        }
    
    }, [user])


    return (
        <div className="orders">
            <div className="container">
            {orders?.map(order => (
                <Order order={order} />
            ))}
            </div>
        </div>
    )
}

export default Orders
